/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Psychosocial Risk Psycology List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './PsychosocialRiskPsycologyListView';

export const mapStateToPropsPsychosocialRiskPsycologyList = mapStateToProps;
export const mapDispatchToPropsPsychosocialRiskPsycologyList =
  mapDispatchToProps;

export default connect(
  mapStateToPropsPsychosocialRiskPsycologyList,
  mapDispatchToPropsPsychosocialRiskPsycologyList
)(View);
